<template>
  <div>
    <!-- 编辑查看提示语弹窗 -->
    <el-form ref="form" :model="model" label-width="80px" label-position="left">
      <el-row>
        <el-col :span="14">
          <el-select
            v-model="model.tipsTempId"
            :disabled="disabled"
            ref="tempRef"
            class="tips-temp"
            popper-class="tips-select-poper"
            placeholder=""
            filterable
            @change="formTipsChange"
          >
            <el-option
              v-for="item in spaceTempList"
              :key="item.tempId"
              :value="item.tempId"
              :label="item.tempName"
            ></el-option>
            <div class="option-btn">
              <el-button type="text" icon="el-icon-plus" @click="setCustomTips">新增自定义提示语</el-button>
            </div>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button v-if="!disabled" type="text" icon="el-icon-delete" @click="handleClear">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-bottom:0">
        <el-col :span="6">
          <el-card shadow="never" class="body-left">
            <div slot="header" class="clearfix">
              <span>提示语列表</span>
              <div style="float: right;">
                <el-button :disabled="disabled" type="text" @click="addTips">增加</el-button>
                <el-button :disabled="disabled" type="text" @click="deleteTips">删除</el-button>
              </div>
            </div>
            <div class="tips-list" :style="{ height: model.detailList.length > 0 ? '267px' : '63px' }">
              <div
                v-for="(item, index) in model.detailList"
                :key="index"
                :class="['tips-item', index === tipsIndex ? 'active' : '']"
                @click="tipsIndex = index"
              >
                <span :title="item.content">{{ item.content }}</span>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="18">
          <el-card header="提示语参数" shadow="never">
            <div v-if="model.detailList.length > 0" :style="{ height: model.detailList.length > 0 ? '228px' : '120px' }">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="场景">
                    <el-select v-model="curTips.screenType" :disabled="disabled" @change="clearTipsTemp">
                      <el-option value="full" label="全屏"></el-option>
                      <el-option value="mini" label="小屏"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="开始时间"
                    :prop="'detailList.' + tipsIndex + '.showTime'"
                    :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                  >
                    <el-input-number
                      v-model="curTips.showTime"
                      :min="-1"
                      :max="curTips.endTime"
                      :step="1"
                      :disabled="disabled"
                      controls-position="right"
                      style="width: 220px"
                      @change="clearTipsTemp"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="结束时间"
                    :prop="'detailList.' + tipsIndex + '.endTime'"
                    :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                  >
                    <el-input-number
                      v-model="curTips.endTime"
                      :min="curTips.showTime"
                      :step="1"
                      :disabled="disabled"
                      controls-position="right"
                      style="width: 220px"
                      @change="clearTipsTemp"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="位置">
                    <el-select v-model="curTips.locationType" :disabled="disabled" filterable @change="clearTipsTemp">
                      <el-option :value="1" label="上左"></el-option>
                      <el-option :value="2" label="上中"></el-option>
                      <el-option :value="3" label="上右"></el-option>
                      <el-option :value="4" label="中左"></el-option>
                      <el-option :value="5" label="居中"></el-option>
                      <el-option :value="6" label="中右"></el-option>
                      <el-option :value="7" label="下左"></el-option>
                      <el-option :value="8" label="下中"></el-option>
                      <el-option :value="9" label="下右"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="上下边距"
                    :prop="'detailList.' + tipsIndex + '.marginY'"
                    :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                  >
                    <el-input-number
                      v-model="curTips.marginY"
                      :min="0"
                      :step="1"
                      :disabled="disabled"
                      controls-position="right"
                      style="width: 100px"
                      @change="clearTipsTemp"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="左右边距"
                    :prop="'detailList.' + tipsIndex + '.marginX'"
                    :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                  >
                    <el-input-number
                      v-model="curTips.marginX"
                      :min="0"
                      :step="1"
                      :disabled="disabled"
                      controls-position="right"
                      style="width: 100px"
                      @change="clearTipsTemp"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="类型">
                    <el-select v-model="curTips.type" :disabled="disabled" filterable @change="changeTipsType">
                      <el-option value="txt" label="文字"></el-option>
                      <el-option value="image" label="图片"></el-option>
                      <el-option value="qrcode" label="二维码"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <template v-if="curTips.type === 'txt'">
                  <el-col :span="8">
                    <el-form-item label="展示样式">
                      <el-select v-model="curTips.textStyle" :disabled="disabled" filterable @change="clearTipsTemp">
                        <el-option :value="1" label="文字阴影"></el-option>
                        <el-option :value="2" label="文字加背景色"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="字号">
                      <el-select v-model="curTips.fontSize" :disabled="disabled" filterable @change="clearTipsTemp">
                        <el-option v-for="item in fontSizeOptions" :key="item" :value="item" :label="item"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </template>
                <template v-else>
                  <el-col :span="8">
                    <el-form-item
                      label="宽度"
                      :prop="'detailList.' + tipsIndex + '.width'"
                      :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                    >
                      <el-input-number
                        v-model="curTips.width"
                        :min="0"
                        :step="1"
                        :disabled="disabled"
                        controls-position="right"
                        style="width: 100px"
                        @change="clearTipsTemp"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="高度"
                      :prop="'detailList.' + tipsIndex + '.height'"
                      :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                    >
                      <el-input-number
                        v-model="curTips.height"
                        :min="0"
                        :step="1"
                        :disabled="disabled"
                        controls-position="right"
                        style="width: 100px"
                        @change="clearTipsTemp"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                </template>
              </el-row>
              <template v-if="curTips.type === 'qrcode'">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item
                      label="背景字号"
                      :prop="'detailList.' + tipsIndex + '.bgFontSize'"
                      :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                    >
                      <el-input-number
                        v-model="curTips.bgFontSize"
                        :min="0"
                        :step="1"
                        :disabled="disabled"
                        controls-position="right"
                        style="width: 100px"
                        @change="clearTipsTemp"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="背景宽度"
                      :prop="'detailList.' + tipsIndex + '.bgW'"
                      :rules="[{ required: true, message: '必须填写', trigger: 'blur' },
                        { validator: validateBgW, trigger: 'blur'}
                      ]"
                    >
                      <el-input-number
                        v-model="curTips.bgW"
                        :min="0"
                        :step="1"
                        :disabled="disabled"
                        controls-position="right"
                        style="width: 100px"
                        @change="clearTipsTemp"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="背景高度"
                      :prop="'detailList.' + tipsIndex + '.bgH'"
                      :rules="[{ required: true, message: '必须填写', trigger: 'blur' },
                        { validator: validateBgH, trigger: 'blur'}
                      ]"
                    >
                      <el-input-number
                        v-model="curTips.bgH"
                        :min="0"
                        :step="1"
                        :disabled="disabled"
                        controls-position="right"
                        style="width: 100px"
                        @change="clearTipsTemp"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item
                      label="背景"
                      :prop="'detailList.' + tipsIndex + '.bgH'"
                      :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                    >
                      <el-upload
                        class="avatar-uploader"
                        accept=".jpg,.jpeg,.png,.gif"
                        action="api/dsp/adDspPartner/uploadFile"
                        :headers="{ token }"
                        :show-file-list="false"
                        :on-success="handleUploadSuccess">
                        <img v-if="curTips.bgImage" :src="curTips.bgImage" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="文案"
                    :prop="'detailList.' + tipsIndex + '.content'"
                    :rules="[{ required: true, message: '必须填写', trigger: 'blur' }]"
                  >
                    <el-input v-model.trim="curTips.content" :disabled="disabled" @change="clearTipsTemp"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import service from '@/services'

export default {
  props: {
    disabled: { type: Boolean, default: false },
    spaceId: { type: Number },
    tipsTempId: { type: Number },
    tipsDetail: { type: String },
    targetEventType: { type: Number }
  },
  data() {
    return {
      spaceTempList: [],
      model: {
        tipsTempId: undefined,
        detailList: []
      },
      tipsIndex: 0,
      fontSizeOptions: [12, 16, 18, 20, 22, 24, 26, 28, 30, 32, 36, 48],
      token: service.state.token
    }
  },
  computed: {
    curTips() {
      return this.model.detailList[this.tipsIndex]
    }
  },
  watch: {
    spaceId: {
      handler(val) {
        this.getTipsTempList()
      }
    },
    tipsDetail: {
      handler(newVal) {
        this.model.tipsTempId = this.tipsTempId === -1 ? undefined : this.tipsTempId
        this.model.detailList = newVal ? JSON.parse(newVal) : []
      }
    },
    model: {
      handler(newVal) {
        const result = {
          tipsTempId: newVal.tipsTempId,
          tipsDetail: newVal.detailList.length ? JSON.stringify(newVal.detailList) : ''
        }
        this.$emit('change-tips', result)
      },
      deep: true
    },
    targetEventType: {
      handler(newVal) {
        if (this.model.tipsTempId !== undefined && this.spaceTempList.length) {
          const tipsTemp = this.spaceTempList.find(item => item.tempId === this.model.tipsTempId) || {}
          this.model.detailList = (tipsTemp.tipsDetail || []).filter(tipsItem => [this.targetEventType, 3, undefined].includes(tipsItem.relatedTargetType))
        }
      },
      deep: true
    }
  },
  created() {
    this.getTipsTempList().then(res => {
      if (this.tipsTempId !== undefined) {
        this.model.tipsTempId = this.tipsTempId === -1 ? undefined : this.tipsTempId
        this.model.detailList = this.tipsDetail ? JSON.parse(this.tipsDetail) : []
      }
    })
  },
  methods: {
    // 获取提示语模板
    getTipsTempList() {
      if (!this.spaceId) {
        return Promise.resolve()
      }
      return this.$service.getAdTempTips({ spaceId: this.spaceId, adTip: 0 }).then((res) => {
        this.spaceTempList = res || []
      })
    },
    // 清空
    handleClear() {
      if (this.model.detailList.length === 0) {
        return
      }
      this.$confirm('提示语将被清空，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false
      })
        .then(() => {
          this.model.tipsTempId = undefined
          this.model.detailList = []
        })
    },
    formTipsChange(val) {
      if (val !== undefined && this.spaceTempList.length) {
        const tipsTemp = this.spaceTempList.find(item => item.tempId === val)
        this.model.detailList = (tipsTemp.tipsDetail || []).filter(tipsItem => [this.targetEventType, 3, undefined].includes(tipsItem.relatedTargetType))
      }
      this.tipsIndex = 0
    },
    // 增加tips
    addTips() {
      this.model.detailList.push({
        screenType: 'full',
        showTime: 0,
        endTime: 0,
        locationType: 1,
        fontSize: 12,
        type: 'txt',
        content: '自定义',
        textStyle: 1,
        marginX: 0,
        marginY: 0,
        width: 0,
        height: 0,
        bgW: 0,
        bgH: 0,
        bgFontSize: 0,
        bgImage: '',
      })
      this.tipsIndex = this.model.detailList.length - 1
      this.clearTipsTemp()
    },
    // 删除tips
    deleteTips() {
      if (this.model.detailList[this.tipsIndex]) {
        this.model.detailList.splice(this.tipsIndex, 1)
        this.tipsIndex = this.model.detailList.length > 0 ? this.model.detailList.length - 1 : 0
        this.clearTipsTemp()
      }
    },
    changeTipsType(type) {
      if (type === 'txt') {
        this.curTips.width = 0
        this.curTips.height = 0
      } else {
        this.curTips.textStyle = 1
        this.curTips.fontSize = 12
      }
      this.clearTipsTemp()
    },
    clearTipsTemp() {
      this.model.tipsTempId = undefined
    },
    setCustomTips() {
      if (this.model.detailList.length === 0) {
        this.model.detailList = []
        this.addTips()
        return
      }
      this.$confirm('此操作会清空原有提示语内容，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false
      })
        .then(() => {
          this.model.detailList = []
          this.addTips()
        })
        .catch(() => {
          this.$refs.tempRef.focus()
        })
    },
    validateBgW(rule, value, callback) {
      if (value < this.curTips.width) {
        callback(new Error('不能小于二维码宽度'))
      } else {
        callback()
      }
    },
    validateBgH(rule, value, callback) {
      if (value < this.curTips.height) {
        callback(new Error('不能小于二维码高度'))
      } else {
        callback()
      }
    },
    handleUploadSuccess(res, file) {
      if (res.code === 0 && res.data) {
        this.curTips.bgImage = res.data.mediaIcon
        this.$forceUpdate()
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.tips-temp.el-select
  margin-right 20px
  min-width 400px
  width calc(100% - 20px)
.tips-item
  padding 10px 20px
  border-bottom 1px solid #e9e9e9
  line-height 40px
  height 40px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
  cursor pointer
  &:hover
    background-color #fffaf3
    color #ff8b00
  &.active
    border-left 4px solid #ff8b00
    background-color #fffaf3
    color #ff8b00
.body-left >>>.el-card__body
  padding 0
.el-card
  min-height 120px
  >>>.el-card__header
    padding 10px 20px
.el-row
  margin-bottom 20px
.el-input-number
  width 100%!important
.option-btn
  position sticky
  background-color #fff
  bottom 0px
  text-align center
  border-top 1px solid #f2f2f2
.tips-list
  overflow-y auto
  &::-webkit-scrollbar
    width 6px
  &::-webkit-scrollbar-track
    border-radius 6px
    background rgba(0, 0, 0, 0.1)
  &::-webkit-scrollbar-thumb
    border-radius 4px
    background rgba(0, 0, 0, 0.2)
</style>

<style lang="stylus">
.tips-select-poper .el-select-dropdown__list
  padding-bottom 0
</style>
